import React, { useState } from 'react';
import {
  AccordionSummary,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import IconTrash from 'shared/icons/trash';
import { makeTransition } from 'shared/lib/utils/utils';

export default observer(function FileNode({
  file,
  onDelete,
  left,
}: {
  file: File;
  onDelete: () => void;
  left: number;
}) {
  const theme = useTheme();
  return (
    <AccordionSummary
      sx={{
        'pl': left,
        '& .MuiAccordionSummary-content': {
          alignItems: 'center',
          gap: 2,
        },
        'transition': makeTransition(['opacity']),
        '& .MuiIconButton-root': {
          opacity: 0,
          pointerEvents: 'none',
        },
        '&:hover .MuiIconButton-root': {
          opacity: 1,
          pointerEvents: 'all',
        },
      }}
    >
      <Typography sx={{ whiteSpace: 'nowrap' }}>{file.name}</Typography>
      <IconButton sx={{ flexShrink: 0 }} onClick={onDelete}>
        <IconTrash extColor={theme.palette.error.main}></IconTrash>
      </IconButton>
    </AccordionSummary>
  );
});
